const RX_WIN_NEWLINES = /\r\n/g;
const RX_NBSP = /\u00A0/g;
const RX_SPACE_BEFORE_NL = /[ \t]+\n/g;
const RX_INDENT_AFTER_NL = /\n[ \t]+/g;
const RX_MULTI_SPACE = /[ \t]{2,}/g;

export function cleanTextNodeData(data) {
  return String(data ?? "")
    .replace(RX_WIN_NEWLINES, "")
    .replace(RX_NBSP, " ")
    .replace(RX_SPACE_BEFORE_NL, "\n")
    .replace(RX_INDENT_AFTER_NL, "\n")
    .replace(RX_MULTI_SPACE, " ");
}